import { createSlice } from '@reduxjs/toolkit';
import { getUserDocApi } from '../../../rtk-apis/auth/getUserDoc';

const initialState = {
  status: '',
  result: '',
  msg: '',
  loading: false,
  accessToken: '',
  dcmAccessToken: null,
  pacsResult: null,
  data: {
    _id: '',
    _rev: '',
    name: '',
    email: '',
    countryCode: '',
    contactDetails: '',
    Address: '',
    ZipCode: '',
    Country: '',
    State: '',
    City: '',
    adminDetails: [],
    type: '',
    role: '',
    createdBy: '',
    createdOn: '',
    tempPassword: '',
    isAdminLogin: false,
    matchingAdmin: null,
  },
  hospitals: [],
  isAdminLogin: false,
};

const getUserDocSlice = createSlice({
  name: 'getUserDoc',
  initialState,
  reducers: {
    clearState: state => {
      state.status = '';
      state.result = '';
      state.msg = '';
      state.loading = false;
      state.accessToken = '';
      state.dcmAccessToken = null;
      state.pacsResult = null;
      state.data = {
        _id: '',
        _rev: '',
        name: '',
        email: '',
        countryCode: '',
        contactDetails: '',
        Address: '',
        ZipCode: '',
        Country: '',
        State: '',
        City: '',
        adminDetails: [],
        type: '',
        role: '',
        createdBy: '',
        createdOn: '',
        tempPassword: '',
        isAdminLogin: false,
        matchingAdmin: null,
      };
      state.hospitals = [];
      state.isAdminLogin = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getUserDocApi.pending, (state, action) => {
        state.status = 'LOADING';
        state.loading = true;
        state.msg = 'LOADING...';
      })
      .addCase(getUserDocApi.fulfilled, (state, action) => {
        state.loading = false;
        state.status = action?.payload?.status || 'SUCCESS';
        state.accessToken = action?.payload?.accessToken || '';
        state.dcmAccessToken = action?.payload?.dcmAccessToken || null;
        state.pacsResult = action?.payload?.pacsResult || null;
        state.data = action?.payload?.data || initialState.data;
        state.result = action?.payload || '';
        state.hospitals = action?.payload?.hospitals || [];
        state.msg = action?.payload?.msg;
        state.isAdminLogin = action?.payload?.isAdminLogin || false;
      })
      .addCase(getUserDocApi.rejected, (state, action) => {
        state.loading = false;
        state.status = 'ERROR';
        state.result = '';
        state.accessToken = '';
        state.dcmAccessToken = null;
        state.pacsResult = null;
        state.data = initialState.data;
        state.isAdminLogin = false;

        const payload = action?.payload;
        if (typeof payload === 'string') {
          state.msg = payload;
          state.hospitals = [];
        } else {
          state.msg = 'Something went wrong!';
          state.hospitals = [];
        }
      });
  },
});

export default getUserDocSlice.reducer;
export const { clearState } = getUserDocSlice.actions;
